import React from "react";
import MapaRecursos from "../images/maparecursos.png";
import NotaRecursos2 from "../images/notarecursos2.png";
import FondoRecursos from "../images/fondorecursos.png";
import NotaRecursos from "../images/notarecursos.png";

import { Helmet } from "react-helmet";
import { makeStyles } from "@material-ui/core/styles";
import Container from "@material-ui/core/Container";
import Grid from "@material-ui/core/Grid";
import Button from "@material-ui/core/Button";

import Banner from "../components/Banner";
import BannerFooter from "../components/BannerFooter";
import Title from "../components/Title";
import TitleSmall from "../components/TitleSmall";

import Actividad from "../components/Actividad";

const useStyles = makeStyles((theme) => ({
  contentLamina: {
    "& img": {
      maxWidth: "100%",
      margin: "0 auto",
    },
    "& p": {
      lineHeight: 1.5,
    },
    margin: "2em auto 4em",
  },
  contentLamina2: {
    "& img": {
      maxWidth: "100%",
      margin: "0 auto",
    },
    "& p": {
      lineHeight: 1.5,
    },
    margin: "2em auto 4em",
    background: theme.palette.secondary.main,
    padding: "2em",
  },
  actividadFondo: {
    backgroundImage: "url(" + FondoRecursos + ")",
    backgroundRepeat: "no-repeat",
    backgroundSize: "cover",
    minHeight: 800,
    width: "100%",
    marginTop: 40,
    display: "flex",
    flexDirection: "column",
    alignItems: "flex-end",
    "& p": {
      lineHeight: 1.5,
      maxWidth: 400,
    },
    marginBottom: "4em",
    [theme.breakpoints.down("md")]: {
      minHeight: 800,
      backgroundPosition: "50%",
    },
    [theme.breakpoints.down("xs")]: {
      minHeight: 900,
      backgroundSize: "100% auto",
      backgroundPosition: "bottom",
      "& p": {
        maxWidth: "100%",
      },
    },
  },
  actividad: {
    background: "#6a2c9138",
    border: "6px solid " + theme.palette.purple.main,
    "& p": {
      marginLeft: "1em",
    },
    marginBottom: "4em",
  },
  options: {
    borderBottom: "1px solid #ccc",
  },
  option: {
    color: theme.palette.blue.main,
    textAlign: "right",
  },
  actividadContent: {
    maxWidth: 800,
  },
}));

const Lamina2 = () => {
  const classes = useStyles();
  return (
    <>
      <Helmet
        title="Ciudadanía activa - Lámina 9: Recursos naturales del Perú"
        meta={[
          {
            property: "og:title",
            content: "Lámina 9: Recursos naturales del Perú",
            dataReactHelmet: true,
          },
          {
            property: "description",
            content:
              "La diversidad de nuestro territorio hace que tengamos una enorme variedad de recursos naturales.",
            dataReactHelmet: true,
          },
        ]}
      />
      <Banner number="9" color="primary" />
      <Container maxWidth="md" className={classes.contentLamina}>
        <Title title="RECURSOS NATURALES DEL PERÚ" color="primary" />
        <Grid
          container
          className={classes.root}
          spacing={1}
          alignItems="center"
          justify="center"
        >
          <Grid item lg={4} md={4} xs={12}>
            <p>
              La diversidad de nuestro territorio hace que tengamos una enorme
              variedad de recursos naturales. Entre ellos, están los bosques,
              los glaciares, los ríos, los lagos, la flora, la fauna, el
              petróleo, los minerales, el gas natural, etc.
            </p>
            <p>
              La explotación adecuada de los recursos naturales juega un papel
              muy importante en el Perú, pues permite generar ingresos que
              benefician nuestra economía.
            </p>
            <p>
              Pero este crecimiento económico y poblacional debe ir de la mano
              con leyes que contribuyan a la protección de los recursos
              naturales.
            </p>
          </Grid>
          <Grid item lg={8} md={8} xs={12}>
            <img src={MapaRecursos} alt="Mapa recursos" />
          </Grid>
        </Grid>
      </Container>
      <Container maxWidth="md" className={classes.contentLamina}>
        <Actividad color="primary" />
        <p>
          <strong>
            Observa. Escribe el número que corresponda junto a cada actividad en
            el mapa.
          </strong>
        </p>
        <Grid container className={classes.root} spacing={1}>
          <Grid item lg={4} md={4} sm={6} xs={12}>
            <div>1. Extracción de petróleo </div>
            <div>2. Pesca</div>
            <div>3. Extracción de madera </div>
            <div>4. Cultivo de cacao</div>
            <div>5. Cultivo de mangos</div>
            <div>6. Cultivo de espárragos</div>
            <div>7. Cultivo de algodón</div>
          </Grid>
          <Grid item lg={4} md={4} sm={6} xs={12}>
            <div>8. Servicios financieros</div>
            <div>9. Cultivo de papa </div>
            <div>10. Cultivo de maíz </div>
            <div>11. Ganadería de camélidos sudamericanos</div>
            <div>12. Cultivo de café </div>
            <div>13. Ganadería de ovejas</div>
          </Grid>
          <Grid item lg={4} md={4} sm={6} xs={12}>
            <div>14. Ganadería de vacunos</div>
            <div>15. Manejo de recursos hídricos</div>
            <div>16. Extracción de oro y minerales</div>
            <div>17. Cultivo de frejoles 18. Cultivo de habas</div>
          </Grid>
        </Grid>
      </Container>
      <Container maxWidth="md" className={classes.contentLamina}>
        <Grid
          container
          className={classes.root}
          spacing={2}
          justify="center"
          alignItems="center"
        >
          <Grid item lg={6} md={6} xs={12}>
            <TitleSmall
              title="UNA SITUACIÓN ADVERSA PARA LOS RECURSOS NATURALES"
              color="primary"
            />
            <p>
              Actualmente, los recursos naturales están expuestos al cambio
              climático (variaciones bruscas de temperatura, retroceso de
              glaciares, sequías, inundaciones, etc.). Los recursos también se
              ven afectados por la contaminación y otros problemas generados por
              su extracción.
            </p>
          </Grid>
          <Grid item lg={6} md={6} xs={12}>
            <img src={NotaRecursos} alt="Nota" />
          </Grid>
        </Grid>
      </Container>
      <Container maxWidth="md" className={classes.contentLamina}>
        <div className={classes.actividadFondo}>
          <Grid container className={classes.root} spacing={2} justify="center">
            <Grid item lg={6} md={6} xs={12}>
              <Actividad color="primary" />
              <p>
                <strong>Lee el siguiente caso y observa la ilustración.</strong>
              </p>
              <p style={{ color: "#0072bc" }}>
                <strong>
                  En el Perú encontramos muchas variedades de papa. Algunas son
                  conocidas como papas nativas. Estas se suelen sembrar en la
                  sierra; se encuentran adaptadas a la altura y se abonan con
                  fertilizantes naturales. En los últimos años, sin embargo, el
                  cambio climático ha venido afectando a las papas nativas. Por
                  ejemplo, en la comunidad de Paru Paru, en Písac (Cusco), los
                  campesinos ahora tienen que cultivarlas arriba de los 3500
                  metros sobre el nivel del mar para que las plagas no las
                  afecten. Esto ocurre porque ahora las temperaturas son más
                  elevadas
                </strong>
              </p>
              <p>
                <strong>
                  Reflexiona sobre las siguientes preguntas y elabora un párrafo
                  o graba tu respuesta en audio o video.
                </strong>
              </p>
              <img src={NotaRecursos2} style={{ maxWidth: 340 }} alt="Nota" />
            </Grid>
            <Grid item lg={6} md={6} xs={12}></Grid>
          </Grid>
        </div>
      </Container>

      <Container maxWidth="md" className={classes.contentLamina}>
        <p>Descargar lámina aquí:</p>
        <Button
          href="https://fundacionmohme.org/wp-content/uploads/2020/06/Ciudadanía-Activa-Lámina-9.pdf"
          rel="noopener noreferrer"
          target="_blank"
          variant="outlined"
          color="primary"
          className="btn-download"
          onClick={() => { window.dataLayer.push({
            'lamina': 'Lámina 9: Recursos naturales del Perú'
          }); }}
        >
          Descargar
        </Button>
      </Container>
      <BannerFooter
        active={true}
        anterior="La dinámica de la ciudad"
        anteriorEnlace="/lamina-1-8"
        siguiente="El cuidado del ambiente"
        siguienteEnlace="/lamina-1-10"
      />
    </>
  );
};

export default Lamina2;
